<template>
  <div class="contentRecord">
    <bread-crumb></bread-crumb>
    <el-row>
      <el-col :span="7">
        <card-body :articleData.sync="paragraphDataLeft" />
      </el-col>
      <el-col :span="7">
        <card-body :articleData.sync="paragraphDataRight" />
      </el-col>
      <el-col :span="10" class="repeatInfo">
        <card-body
          :articleData.sync="paragraphData"
          v-if="data && data[paragraphId]"
        >
          <h1 v-if="data[paragraphId].similarity">
            相似度：{{ `${(data[paragraphId].similarity * 100).toFixed(0)}%` }}
          </h1>
          <h1 v-if="data[paragraphId].name">
            作者：{{ data[paragraphId].name }}
          </h1>
          <h1 v-if="data[paragraphId].url">
            链接：<el-link
              type="primary"
              :href="data[paragraphId].url"
              target="_blank"
              >{{ data[paragraphId].url }}</el-link
            >
          </h1>
          <div class="item-table">
            <el-table
              :data="data"
              border
              size="mini"
              :highlight-current-row="true"
              :row-class-name="tableRowClassName"
              height="262"
              style="width: 100%"
            >
              <el-table-column
                label="序号"
                type="index"
                align="center"
                width="60"
              >
              </el-table-column>
              <el-table-column
                prop="vioTitle"
                label="侵权文章"
                align="center"
                width="180"
                show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="similarity"
                align="center"
                label="相似度"
                width="64"
              >
                <template slot-scope="scope">
                  {{
                    `${
                      scope.row["similarity"] &&
                      (scope.row["similarity"] * 100).toFixed(0)
                    }%`
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="侵权作者"
                align="center"
                show-overflow-tooltip="true"
                width="70"
              >
              </el-table-column>
              <el-table-column
                prop="platform"
                label="侵权平台"
                width="70"
                align="center"
                show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" width="60">
                <template slot-scope="scope">
                  <el-button
                    @click="redirectTo(scope.$index)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <pagination
              @sizePageChange="paginationChangeProduct"
              :paginationDatas="paginationDataProduct"
            ></pagination>
          </div>
        </card-body>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import breadCrumb from "@/components/breadCrumb";
import cardBody from "./components/cardBody";
import { healthCmpBizPageDuplicateRecord } from "@/api/man";
export default {
  name: "medicalCenter",
  data() {
    return {
      articleId: "",
      paragraphId: 0,
      data: [],
      paragraphData: {
        title: "相似来源",
      },
      paragraphDataLeft: {
        title: "京东健康文章",
        contentTitle: "",
        content: "",
        num: 0,
      },
      paragraphDataRight: {
        title: "",
        contentTitle: "",
        content: "",
        num: 0,
      },
      pageSize: "",
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pagerCount: 3,
        pageSizes: [5, 10, 20, 30, 50],
      },
    };
  },
  created() {
    this.articleId = this.$route.query.id;
    this.paragraphId = this.$route.query.paragraphId;
    this.pageSize = this.$route.query.pageSizes;
    this.type = this.$route.query.type;
    this.healthCmpBizPageDuplicateRecord(
      this.articleId,
      this.$commonJs.getTenantId(),
      this.type,
      1,
      this.pageSize
    );
  },
  components: {
    breadCrumb,
    cardBody,
    pagination,
  },
  watch: {
    pageSize(newVal, oldVal) {
      this.$router.push({
        query: {
          ...this.$route.query,
          pageSizes: newVal,
        },
      });
      if (newVal < this.paragraphId) {
        this.paragraphId = newVal - 1;
      }
      this.paginationDataProduct.pageSize = newVal;
    },
    paragraphId(newVal, oldVal) {
      this.$router.push({
        query: {
          ...this.$route.query,
          paragraphId: newVal,
        },
      });
      this.initData(this.data);
    },
  },
  methods: {
    initData(data) {
      const i = this.paragraphId;
      this.paragraphDataLeft = {
        ...this.paragraphDataLeft,
        contentTitle: data[i].title,
        content: data[i].content,
        num: data[i].words,
      };
      this.paragraphDataRight = {
        ...this.paragraphDataRight,
        title: data[i].platform,
        contentTitle: data[i].vioTitle,
        content: data[i].vioContent,
        num: data[i].vioWords,
      };
    },
    healthCmpBizPageDuplicateRecord(
      contentId,
      tenantId,
      sourceType,
      pageNo,
      pageSize
    ) {
      healthCmpBizPageDuplicateRecord({
        tenantId,
        contentId,
        sourceType,
        pageNo,
        pageSize,
      }).then((res) => {
        const { data, ...pageConfig } = res;
        this.data = data;
        if (this.data.length < pageConfig.pageSize) {
          this.paragraphId = 0;
        }
        this.initData(data);
        this.paginationDataProduct = {
          ...this.paginationDataProduct,
          total: pageConfig.totalCount,
          currentPage: pageConfig.pageNo,
          pageSize: pageConfig.pageSize,
        };
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex == this.paragraphId) {
        return "active-row";
      }
      return "";
    },
    paginationChangeProduct(val) {
      this.pageSize = val.pageSize;
      this.paginationDataProduct = val;
      this.healthCmpBizPageDuplicateRecord(
        this.articleId,
        this.$commonJs.getTenantId(),
        this.type,
        this.paginationDataProduct.currentPage,
        this.paginationDataProduct.pageSize
      );
    },
    redirectTo(id) {
      this.paragraphId = id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/element.scss";
.contentRecord {
  :deep(.el-card) {
    border-radius: 0;
    border: 0;
    .el-card__body {
      padding: 0;
      border: 0;
      border: 1px solid #e6e6e6;
      height: 82vh;
      overflow-y: auto;
    }
  }
  :deep(.el-pagination__editor.el-input) {
    width: 35px;
  }
  :deep(.el-pagination__total) {
    margin-right: 0;
  }
  :deep(.el-pagination__sizes) {
    margin: 0;
  }
  :deep(.el-pagination .el-select .el-input) {
    width: 77px;
  }
  :deep(.el-pagination__jump) {
    margin-left: 0;
  }
  :deep(.el-table .active-row) {
    background-color: #f5f7fa;
  }
  :deep(.el-table__body-wrapper),
  :deep(.articleContent) {
    &::-webkit-scrollbar {
      width: 5px;
      height: 16px;
      background-color: #f5f5f5;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(56, 56, 56, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #a7a7a7;
    }
  }
  .repeatInfo {
    h1 {
      font-size: 15px;
      margin-bottom: 10px;
      max-width: 300px;
      word-break: break-all;
      :deep(a) {
        display: inline;
        line-height: 20px;
      }
    }
  }
  .item-table {
    max-width: fit-content;
  }
}
</style>
